import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TermsData, UploadTermsResponse } from '../Models/terms';

@Injectable({
    providedIn: 'root'
})
export class TermsService {
   baseurl=`${environment.baseUrl}`
    constructor(private http: HttpClient) { }

    getTerms(userType?: string): Observable<TermsData[]> {
        let url = `${this.baseurl}/admin/terms`;
        if (userType) {
            url += `?userType=${userType}`;
        }
        return this.http.get<TermsData[]>(url);
    }

    uploadTerms(file: File, userType: string): Observable<UploadTermsResponse> {
        const formData = new FormData();
        formData.append('File', file);
        formData.append('UserType', userType);
        return this.http.post<UploadTermsResponse>(`${this.baseurl}/admin/upload-terms`, formData);
    }
}
